function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLamp(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M12 2a8 8 0 014.618 14.533L15.2 22H8.8L7.38 16.533A8 8 0 0112 2zM9.658 17.652L10.2 20h3.599l.542-2.348a7.965 7.965 0 01-1.59.313h-1.5a7.964 7.964 0 01-1.593-.313zM12 4a6 6 0 100 12 6 6 0 000-12zm-2 3.852v2.381l1.553-.776a1 1 0 01.77-.051l.124.051 1.553.777V7.852h2v4a1 1 0 01-1.341.94l-.106-.046L12 11.47l-2.553 1.276a1 1 0 01-1.44-.779L8 11.852v-4h2z",
    fill: "#0A1633",
    fillRule: "evenodd"
  }));
}

SvgLamp.clsName = 'icon-www__lamp';
SvgLamp.remarkName = 'unknown';
export default SvgLamp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Lamp.js
// module id = 2373
// module chunks = 17 18